export const loader = {
  getHtml: function () {
    return '<div id="loader" class="overlay overlay_light"><div class="overlay__inner"><div class="overlay__content"><span class="spinner"></span></div></div></div>';
  },
  show: function () {
    $('body').append(this.getHtml());
  },
  hide: function () {
    $('#loader').remove();
  }
}